// Shared iframe rendering utilities — used by BuildStage and ReviewStage

// Injected into every iframe for nav interception + element selection + inline editing
export const IFRAME_INJECTION = `<script>
(function(){
  var selectMode=false, hoverEl=null, pickedEl=null, hoverLabel=null, selectLabel=null;
  var inlineEditEl=null, inlineEditOrigHTML=null;
  function postSelection(el){
    if(!el)return;
    window.parent.postMessage({
      type:'wf_select',
      outerHTML:el.outerHTML.substring(0,6000),
      tagName:el.tagName.toLowerCase(),
      classList:(typeof el.className==='string'?el.className:'')||'',
      textContent:(el.textContent||'').trim().substring(0,150),
      computedStyles:getStyles(el),
      src:(el.tagName==='IMG'?el.getAttribute('src'):null),
      href:(el.closest('a')?el.closest('a').getAttribute('href'):(el.getAttribute&&el.getAttribute('href'))||null),
      cssPath:cssPath(el)
    },'*');
  }

  function makeLabel(text,color){
    var d=document.createElement('div');
    d.textContent=text;
    d.style.cssText='position:absolute;z-index:999999;pointer-events:none;font-family:ui-monospace,monospace;font-size:11px;line-height:1;padding:2px 6px;border-radius:4px;white-space:nowrap;background:'+color+';color:#0E0E0E;font-weight:600;';
    document.body.appendChild(d);
    return d;
  }
  function positionLabel(label,el,above){
    var r=el.getBoundingClientRect();
    label.style.left=(r.left+window.scrollX)+'px';
    label.style.top=(above?r.top+window.scrollY-20:r.top+window.scrollY-20)+'px';
  }
  function removeLabel(label){if(label&&label.parentNode)label.parentNode.removeChild(label);return null;}
  function getTagLabel(el){
    var tag=el.tagName.toLowerCase();
    var cls=(typeof el.className==='string'?el.className:'').split(/\\s+/).filter(Boolean).slice(0,2).join('.');
    return cls?tag+'.'+cls:tag;
  }
  function clearHighlight(){
    if(hoverEl){hoverEl.style.outline='';hoverEl.style.outlineOffset='';hoverEl=null;}
    hoverLabel=removeLabel(hoverLabel);
  }
  function clearSelection(){
    if(pickedEl){pickedEl.style.outline='';pickedEl.style.outlineOffset='';pickedEl=null;}
    selectLabel=removeLabel(selectLabel);
  }
  function cssPath(el){
    var parts=[];
    var cur=el;
    while(cur&&cur!==document.body&&cur!==document.documentElement){
      var tag=cur.tagName.toLowerCase();
      if(cur.id){parts.unshift(tag+'#'+cur.id);break;}
      var parent=cur.parentElement;
      if(parent){
        var siblings=Array.from(parent.children).filter(function(c){return c.tagName===cur.tagName;});
        if(siblings.length>1){
          var idx=siblings.indexOf(cur)+1;
          parts.unshift(tag+':nth-of-type('+idx+')');
        }else{parts.unshift(tag);}
      }else{parts.unshift(tag);}
      cur=parent;
    }
    return parts.join(' > ');
  }
  function bestTarget(t){
    var el=t;
    if(el.nodeType===3)el=el.parentElement;
    if(!el||el===document.body||el===document.documentElement)return null;
    return el;
  }
  function getStyles(el){
    var cs=window.getComputedStyle(el);
    return {
      // Typography
      fontSize:cs.fontSize,fontWeight:cs.fontWeight,fontFamily:cs.fontFamily,
      fontStyle:cs.fontStyle,textAlign:cs.textAlign,lineHeight:cs.lineHeight,
      letterSpacing:cs.letterSpacing,wordSpacing:cs.wordSpacing,
      textTransform:cs.textTransform,textDecoration:cs.textDecoration,textShadow:cs.textShadow,
      color:cs.color,
      // Background
      backgroundColor:cs.backgroundColor,backgroundImage:cs.backgroundImage,
      backgroundSize:cs.backgroundSize,backgroundPosition:cs.backgroundPosition,
      // Spacing
      paddingTop:cs.paddingTop,paddingRight:cs.paddingRight,
      paddingBottom:cs.paddingBottom,paddingLeft:cs.paddingLeft,
      marginTop:cs.marginTop,marginRight:cs.marginRight,
      marginBottom:cs.marginBottom,marginLeft:cs.marginLeft,
      // Border
      borderRadius:cs.borderRadius,borderWidth:cs.borderWidth,
      borderColor:cs.borderColor,borderStyle:cs.borderStyle,
      // Effects
      boxShadow:cs.boxShadow,opacity:cs.opacity,
      transform:cs.transform,filter:cs.filter,
      backdropFilter:cs.backdropFilter,mixBlendMode:cs.mixBlendMode,
      // Layout
      display:cs.display,
      flexDirection:cs.flexDirection,justifyContent:cs.justifyContent,
      alignItems:cs.alignItems,gap:cs.gap,flexWrap:cs.flexWrap,
      gridTemplateColumns:cs.gridTemplateColumns,gridTemplateRows:cs.gridTemplateRows,
      // Sizing
      width:cs.width,height:cs.height,
      minWidth:cs.minWidth,maxWidth:cs.maxWidth,
      minHeight:cs.minHeight,maxHeight:cs.maxHeight,
      aspectRatio:cs.aspectRatio,
      // Position
      position:cs.position,top:cs.top,left:cs.left,right:cs.right,bottom:cs.bottom,
      zIndex:cs.zIndex,
      // Overflow
      overflowX:cs.overflowX,overflowY:cs.overflowY,
      // Misc
      cursor:cs.cursor
    };
  }

  // ── Inline text editing ──
  var INLINE_TEXT_TAGS=['h1','h2','h3','h4','h5','h6','p','span','li','a','button','label','td','th','dt','dd','caption','blockquote','strong','em','b','i'];
  function startInlineEdit(el){
    if(!el||el===document.body)return;
    var tag=el.tagName.toLowerCase();
    if(INLINE_TEXT_TAGS.indexOf(tag)===-1)return;
    if(inlineEditEl)commitInlineEdit();
    inlineEditEl=el;
    inlineEditOrigHTML=el.innerHTML;
    el.setAttribute('contenteditable','true');
    el.style.outline='2px solid #60a5fa';
    el.style.outlineOffset='2px';
    el.focus();
    // Select all text
    try{var range=document.createRange();range.selectNodeContents(el);var sel=window.getSelection();sel.removeAllRanges();sel.addRange(range);}catch(ex){}
  }
  function commitInlineEdit(){
    if(!inlineEditEl)return;
    var el=inlineEditEl;
    var changed=el.innerHTML!==inlineEditOrigHTML;
    var path=cssPath(el);
    var newOuter=el.outerHTML.substring(0,10000);
    el.removeAttribute('contenteditable');
    el.style.outline='';
    el.style.outlineOffset='';
    inlineEditEl=null;
    inlineEditOrigHTML=null;
    if(changed){
      window.parent.postMessage({type:'wf_text_changed',cssPath:path,outerHTML:newOuter},'*');
    }
  }
  function cancelInlineEdit(){
    if(!inlineEditEl)return;
    inlineEditEl.innerHTML=inlineEditOrigHTML;
    inlineEditEl.removeAttribute('contenteditable');
    inlineEditEl.style.outline='';
    inlineEditEl.style.outlineOffset='';
    inlineEditEl=null;
    inlineEditOrigHTML=null;
  }

  // Click handler
  document.addEventListener('click',function(e){
    // If inside inline edit, let it handle normally
    if(inlineEditEl&&inlineEditEl.contains(e.target))return;
    // Commit edit if click is outside
    if(inlineEditEl)commitInlineEdit();

    // Navigation intercept (only when NOT in select mode)
    if(!selectMode){
      var a=e.target.closest('a');
      if(a){
        var href=a.getAttribute('href');
        if(!href || href==='#') { e.preventDefault(); return; }
        if(href.startsWith('#')) {
          e.preventDefault();
          var target=document.querySelector(href);
          if(target) target.scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        if(href.startsWith('http')||href.startsWith('mailto:')||href.startsWith('tel:')) { e.preventDefault(); return; }
        e.preventDefault();
        e.stopPropagation();
        var clean=href.replace(/^\\.?\\/?/,'').replace(/\\.html$/,'').replace(/[?#].*$/,'').replace(/\\/+$/,'');
        window.parent.postMessage({type:'wf_navigate',href:clean||'home'},'*');
      }
      return;
    }
    // Select mode — pick the element
    e.preventDefault();
    e.stopPropagation();
    var el=bestTarget(e.target);
    if(!el)return;
    clearHighlight();
    clearSelection();
    pickedEl=el;
    el.style.outline='1.5px dashed #D4B896';
    el.style.outlineOffset='3px';
    selectLabel=makeLabel(getTagLabel(el),'#D4B896');
    positionLabel(selectLabel,el,true);
    postSelection(el);
    var onLeave=function(){
      document.removeEventListener('mouseleave',onLeave);
      if(pickedEl){
        window.parent.postMessage({type:'wf_default_styles',computedStyles:getStyles(pickedEl)},'*');
      }
    };
    document.addEventListener('mouseleave',onLeave);
  },true);

  // Double-click: start inline text edit (only when NOT in select mode)
  document.addEventListener('dblclick',function(e){
    if(selectMode)return;
    var el=bestTarget(e.target);
    if(!el)return;
    e.preventDefault();
    e.stopPropagation();
    startInlineEdit(el);
  },true);

  // Keyboard: Esc cancels, Enter commits single-line inline edits
  document.addEventListener('keydown',function(e){
    if(!inlineEditEl)return;
    if(e.key==='Escape'){e.preventDefault();cancelInlineEdit();}
    else if(e.key==='Enter'){
      var tag=inlineEditEl.tagName.toLowerCase();
      var singleLine=['h1','h2','h3','h4','h5','h6','button','a','label','span'];
      if(singleLine.indexOf(tag)!==-1){e.preventDefault();commitInlineEdit();}
    }
  });

  // Hover highlight
  document.addEventListener('mouseover',function(e){
    if(!selectMode)return;
    var el=bestTarget(e.target);
    if(!el||el===pickedEl||el===hoverEl)return;
    clearHighlight();
    hoverEl=el;
    el.style.outline='1.5px dotted rgba(212,184,150,0.5)';
    el.style.outlineOffset='3px';
    hoverLabel=makeLabel(getTagLabel(el),'rgba(212,184,150,0.7)');
    positionLabel(hoverLabel,el,true);
  });
  document.addEventListener('mouseout',function(e){
    if(selectMode)clearHighlight();
  });

  document.addEventListener('contextmenu',function(e){
    if(!selectMode)return;
    var el=bestTarget(e.target);
    if(!el)return;
    e.preventDefault();
    e.stopPropagation();
    clearHighlight();
    clearSelection();
    pickedEl=el;
    el.style.outline='1.5px dashed #D4B896';
    el.style.outlineOffset='3px';
    selectLabel=makeLabel(getTagLabel(el),'#D4B896');
    positionLabel(selectLabel,el,true);
    postSelection(el);
    window.parent.postMessage({
      type:'wf_context_menu',
      x:e.clientX,
      y:e.clientY,
      cssPath:cssPath(el)
    },'*');
  },true);

  // Message handler
  window.addEventListener('message',function(e){
    if(!e.data||!e.data.type)return;
    switch(e.data.type){
      case 'wf_set_select_mode':
        if(inlineEditEl)commitInlineEdit();
        selectMode=!!e.data.value;
        document.body.style.cursor=selectMode?'crosshair':'';
        clearHighlight();
        clearSelection();
        break;
      case 'wf_apply_style':
        if(pickedEl)Object.assign(pickedEl.style,e.data.styles);
        break;
      case 'wf_apply_pseudo_style':
        if(!pickedEl)break;
        var ps2=e.data.pseudo;
        var pStyles=e.data.styles||{};
        var cn2=typeof pickedEl.className==='string'?pickedEl.className.trim():'';
        var firstCls=cn2?cn2.split(/\\s+/).filter(Boolean)[0]:'';
        var sel2=firstCls?'.'+firstCls:pickedEl.tagName.toLowerCase();
        var cssDecls=Object.keys(pStyles).map(function(k){
          return k.replace(/([A-Z])/g,function(m){return '-'+m.toLowerCase();})+':'+pStyles[k];
        }).join(';');
        var liveStyle=document.getElementById('wf-pseudo-live');
        if(!liveStyle){liveStyle=document.createElement('style');liveStyle.id='wf-pseudo-live';document.head.appendChild(liveStyle);}
        liveStyle.textContent=sel2+':'+ps2+'{'+cssDecls+'}';
        break;
      case 'wf_replace_image':
        if(pickedEl&&pickedEl.tagName==='IMG'){pickedEl.src=e.data.src;}
        break;
      case 'wf_get_pseudo_styles':
        if(!pickedEl)break;
        var pseudo=e.data.pseudo||'hover';
        var result={};
        try{
          var cn=typeof pickedEl.className==='string'?pickedEl.className:'';
          var classes=cn?cn.trim().split(/\\s+/):[];
          var tag=pickedEl.tagName.toLowerCase();
          var found=false;
          for(var si=0;si<document.styleSheets.length;si++){
            try{
              var rules=document.styleSheets[si].cssRules||document.styleSheets[si].rules||[];
              for(var ri=0;ri<rules.length;ri++){
                var r=rules[ri];
                if(!r.selectorText||!r.style)continue;
                var sels=r.selectorText.toLowerCase();
                if(sels.indexOf(':'+pseudo)===-1)continue;
                var matched=false;
                for(var ci=0;ci<classes.length;ci++){
                  if(classes[ci]&&sels.indexOf('.'+classes[ci].toLowerCase()+':'+pseudo)!==-1)matched=true;
                }
                if(!matched&&sels.indexOf(tag+':'+pseudo)!==-1)matched=true;
                if(matched){
                  found=true;
                  var st=r.style;
                  ['color','backgroundColor','borderColor','borderWidth','borderRadius','fontSize','fontWeight','opacity','boxShadow','padding','margin','transform'].forEach(function(p){
                    if(st[p])result[p]=st[p];
                  });
                }
              }
            }catch(ex){}
          }
          if(!found)result._empty=true;
        }catch(ex2){result._error=true;}
        window.parent.postMessage({type:'wf_pseudo_styles',pseudo:pseudo,styles:result},'*');
        break;
      case 'wf_highlight_changed':
        var ht=e.data.cssPath?document.querySelector(e.data.cssPath):null;
        if(ht){
          ht.style.outline='2px solid #4ade80';
          ht.style.outlineOffset='2px';
          ht.style.transition='outline-color 2s ease-out';
          setTimeout(function(){
            ht.style.outlineColor='transparent';
            setTimeout(function(){ht.style.outline='';ht.style.outlineOffset='';ht.style.transition='';},2000);
          },500);
        }
        break;
      case 'wf_highlight_element':
        // Layers panel hover: highlight without selecting
        var hle=e.data.cssPath?document.querySelector(e.data.cssPath):null;
        if(hle){
          hle.style.outline='2px solid #818cf8';
          hle.style.outlineOffset='2px';
          setTimeout(function(){hle.style.outline='';hle.style.outlineOffset='';},1500);
        }
        break;
      case 'wf_select_element':
        // Layers panel click: programmatically select element
        var sle=e.data.cssPath?document.querySelector(e.data.cssPath):null;
        if(sle){
          clearHighlight();clearSelection();
          pickedEl=sle;
          sle.style.outline='1.5px dashed #D4B896';
          sle.style.outlineOffset='3px';
          selectLabel=makeLabel(getTagLabel(sle),'#D4B896');
          positionLabel(selectLabel,sle,true);
          postSelection(sle);
        }
        break;
      case 'wf_set_background':
        var bgtarget=e.data.cssPath?document.querySelector(e.data.cssPath):pickedEl;
        if(bgtarget){
          if(e.data.backgroundColor)bgtarget.style.backgroundColor=e.data.backgroundColor;
          if(e.data.backgroundImage!==undefined)bgtarget.style.backgroundImage=e.data.backgroundImage;
          if(e.data.backgroundSize)bgtarget.style.backgroundSize=e.data.backgroundSize;
          if(e.data.backgroundPosition)bgtarget.style.backgroundPosition=e.data.backgroundPosition;
        }
        break;
    }
    // Re-init Lucide after any DOM changes
    if(typeof lucide!=='undefined' && ['wf_apply_style','wf_highlight_changed','wf_replace_image','wf_set_background'].indexOf(e.data.type)!==-1){
      setTimeout(function(){try{lucide.createIcons();}catch(ex){}},100);
    }
  });

  // Initialize Lucide icons if the library is loaded
  if(typeof lucide!=='undefined'){try{lucide.createIcons();}catch(e){}}

  // ── Section Drag & Drop + Context Menu ──
  var dragSrcIdx=null;
  var ctxMenu=null;

  function getTopSections(){
    var body=document.body;
    var main=body.querySelector('main');
    if(main){var ms=Array.from(main.children).filter(function(el){return el.tagName&&el.tagName.toLowerCase()==='section';});if(ms.length>0)return ms;}
    var direct=Array.from(body.children).filter(function(el){return el.tagName&&el.tagName.toLowerCase()==='section';});
    if(direct.length>0)return direct;
    return Array.from(document.querySelectorAll('section'));
  }

  function removeCtxMenu(){if(ctxMenu){ctxMenu.remove();ctxMenu=null;}}

  function showSectionCtxMenu(x,y,sidx,total){
    removeCtxMenu();
    ctxMenu=document.createElement('div');
    ctxMenu.style.cssText='position:fixed;z-index:2147483647;left:'+x+'px;top:'+y+'px;background:#18181b;border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:4px;min-width:190px;box-shadow:0 8px 24px rgba(0,0,0,0.6);font-family:system-ui,sans-serif;font-size:12px;';
    var items=[
      {label:'↑  Move up',action:'move_up',dis:sidx===0},
      {label:'↓  Move down',action:'move_down',dis:sidx===total-1},
      {label:'⊞  Duplicate section',action:'duplicate'},
      {label:'✦  Regenerate with AI',action:'regenerate'},
      {label:'✕  Delete section',action:'delete',danger:true},
    ];
    items.forEach(function(item){
      var btn=document.createElement('button');
      btn.textContent=item.label;
      btn.disabled=!!item.dis;
      btn.style.cssText='display:block;width:100%;text-align:left;padding:7px 12px;border:none;background:none;color:'+(item.danger?'#f87171':'#e4e4e7')+';cursor:'+(item.dis?'not-allowed':'pointer')+';border-radius:6px;opacity:'+(item.dis?'0.4':'1')+';font-size:12px;';
      btn.addEventListener('mouseenter',function(){if(!item.dis)btn.style.background='rgba(255,255,255,0.08)';});
      btn.addEventListener('mouseleave',function(){btn.style.background='none';});
      if(!item.dis){
        btn.addEventListener('click',function(){
          removeCtxMenu();
          window.parent.postMessage({type:'wf_section_action',action:item.action,sectionIdx:sidx},'*');
        });
      }
      ctxMenu.appendChild(btn);
    });
    document.body.appendChild(ctxMenu);
    setTimeout(function(){document.addEventListener('click',removeCtxMenu,{once:true});},0);
  }

  function initSectionUI(){
    document.querySelectorAll('.wf-sec-handle').forEach(function(h){h.remove();});
    removeCtxMenu();
    var secs=getTopSections();
    secs.forEach(function(sec,idx){
      sec.setAttribute('draggable','true');
      sec._wfIdx=idx;
      // Ensure relative positioning for handle
      var pos=window.getComputedStyle(sec).position;
      if(pos==='static')sec.style.position='relative';
      // Drag handle bar
      var handle=document.createElement('div');
      handle.className='wf-sec-handle';
      handle.innerHTML='<span style="font-size:14px;margin-right:6px;">⠿</span>Section '+(idx+1);
      handle.style.cssText='position:absolute;top:0;left:50%;transform:translateX(-50%);z-index:99999;display:none;background:rgba(10,10,20,0.82);color:#B8CCDF;font-size:11px;font-weight:600;padding:3px 12px;border-radius:0 0 6px 6px;cursor:grab;pointer-events:auto;white-space:nowrap;font-family:ui-monospace,monospace;border:1px solid rgba(184,204,223,0.3);border-top:none;user-select:none;';
      sec.appendChild(handle);
      if(sec.dataset.wfSectionBound==='1')return;
      sec.dataset.wfSectionBound='1';
      // Show/hide handle on section hover (not during inline edit)
      sec.addEventListener('mouseenter',function(){
        var h=sec.querySelector('.wf-sec-handle');
        if(h&&!inlineEditEl)h.style.display='block';
      });
      sec.addEventListener('mouseleave',function(){
        var h=sec.querySelector('.wf-sec-handle');
        if(h)h.style.display='none';
      });
      // Drag events
      sec.addEventListener('dragstart',function(e){
        dragSrcIdx=sec._wfIdx;
        e.dataTransfer.effectAllowed='move';
        sec.style.opacity='0.35';
      });
      sec.addEventListener('dragend',function(){sec.style.opacity='';});
      sec.addEventListener('dragover',function(e){
        e.preventDefault();
        e.dataTransfer.dropEffect='move';
        sec.style.outline='2px dashed #B8CCDF';
        sec.style.outlineOffset='-2px';
      });
      sec.addEventListener('dragleave',function(){sec.style.outline='';sec.style.outlineOffset='';});
      sec.addEventListener('drop',function(e){
        e.preventDefault();
        sec.style.outline='';sec.style.outlineOffset='';
        var targetIdx=sec._wfIdx;
        if(dragSrcIdx===null||dragSrcIdx===targetIdx)return;
        // Build new order array (original indices)
        var secsNow=getTopSections();
        if(!secsNow.length)return;
        var reordered=secsNow.slice();
        var moved=reordered.splice(dragSrcIdx,1)[0];
        reordered.splice(targetIdx,0,moved);
        var order=reordered.map(function(s){return s._wfIdx;});
        window.parent.postMessage({type:'wf_sections_reordered',order:order},'*');
        dragSrcIdx=null;
        // Re-insert sections in new DOM order for live preview
        var parent=reordered[0].parentElement;
        reordered.forEach(function(s){parent.appendChild(s);});
        setTimeout(initSectionUI,150);
      });
      // Right-click context menu
      sec.addEventListener('contextmenu',function(e){
        if(selectMode)return;
        e.preventDefault();
        showSectionCtxMenu(e.clientX,e.clientY,sec._wfIdx,getTopSections().length);
      });
    });
  }

  function scheduleSectionUIInit(attempt){
    var secs=getTopSections();
    if(secs.length>0||attempt>=20){
      initSectionUI();
      return;
    }
    setTimeout(function(){scheduleSectionUIInit(attempt+1);},250);
  }

  // Run section UI init after page settles
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){scheduleSectionUIInit(0);});}
  else{scheduleSectionUIInit(0);}

  // Handle section reload request from parent (after backend persists reorder)
  // (handled by iframe src reset in ReviewStage)

  // Cleanup markers when the iframe document unloads during page switches.
  window.addEventListener('beforeunload',function(){
    removeCtxMenu();
    document.querySelectorAll('.wf-sec-handle').forEach(function(h){h.remove();});
  });

  // Signal ready to parent
  window.parent.postMessage({type:'wf_iframe_ready'},'*');
})();
<\/script>`;

export function extractAndStripImport(css) {
  if (!css) return { linkTag: '', cleanCss: '' };
  const match = css.match(/@import\s+url\(['"]?(.*?)['"]?\)\s*;?/);
  if (!match) return { linkTag: '', cleanCss: css };
  const linkTag = `<link rel="stylesheet" href="${match[1]}">`;
  const cleanCss = css.replace(match[0], '').trimStart();
  return { linkTag, cleanCss };
}

// Strip raw @import lines that appear outside <style> tags (AI sometimes injects them as plain text)
function fixRawImports(html) {
  // Find @import url(...) lines that appear between </style> and <style>, or before <style>, or after </head>
  // These show as visible text. Convert them to <link> in <head>.
  const importRegex = /(?:<\/style>\s*)?(@import\s+url\(['"]?(https?:\/\/fonts\.googleapis\.com[^'")\s]+)['"]?\)\s*;?)(?:\s*<style>)?/gi;
  let result = html;
  const links = [];
  result = result.replace(importRegex, (match, fullImport, url) => {
    // Only strip if it's truly outside a <style> block (raw in body)
    links.push(`<link rel="stylesheet" href="${url}">`);
    return match.replace(fullImport, '').trim();
  });
  // Inject collected links into <head>
  if (links.length > 0 && result.includes('</head>')) {
    result = result.replace('</head>', `${links.join('\n')}\n</head>`);
  }
  return result;
}

const DARK_SCROLLBAR_CSS = `<style>*{scrollbar-width:thin;scrollbar-color:#262626 #161616}::-webkit-scrollbar{width:6px;height:6px}::-webkit-scrollbar-track{background:#161616}::-webkit-scrollbar-thumb{background:#262626;border-radius:3px}::-webkit-scrollbar-thumb:hover{background:#333}</style>`;

// Baseline quality CSS — fallback when backend orbis-polish is not present
const QUALITY_CSS_FALLBACK = `<style id="orbis-polish-fallback">
  :root{--ease-out-expo:cubic-bezier(0.16,1,0.3,1);--ease-out-back:cubic-bezier(0.34,1.56,0.64,1);--ease-in-out-cubic:cubic-bezier(0.65,0,0.35,1);--ease-spring:cubic-bezier(0.175,0.885,0.32,1.275)}
  html{scroll-behavior:smooth}
  body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility}
  *:focus-visible{outline:2px solid currentColor;outline-offset:2px}
  a,button,[role="button"]{transition:color 200ms var(--ease-out-expo),background-color 200ms var(--ease-out-expo),border-color 200ms var(--ease-out-expo),box-shadow 200ms var(--ease-out-expo),transform 150ms var(--ease-spring),opacity 200ms var(--ease-out-expo)}
  button:active,[role="button"]:active,.btn:active{transform:scale(0.97)}
  .bg-card,[class*="rounded-xl"],[class*="rounded-lg"]{transition:transform 200ms var(--ease-out-expo),box-shadow 200ms var(--ease-out-expo)}
  .bg-card:hover,[class*="rounded-xl"]:hover,[class*="rounded-lg"]:hover{transform:translateY(-2px);box-shadow:0 4px 12px rgba(0,0,0,0.06),0 16px 40px rgba(0,0,0,0.08)}
  input:focus,textarea:focus,select:focus{border-color:var(--color-primary,#6366f1);box-shadow:0 0 0 3px rgba(99,102,241,0.1);outline:none}
  img:not([class*="rounded-full"]):not([class*="rounded-none"]){border-radius:var(--radius,8px)}
  img{max-width:100%;height:auto}
</style>`;

export function buildSrcDoc(html, css, js) {
  if (!html) return '';
  // Safety: fix any raw @import that would render as visible text
  html = fixRawImports(html);
  const { linkTag, cleanCss } = extractAndStripImport(css);
  const styleTag = cleanCss ? `<style>${cleanCss}</style>` : '';
  const scriptTag = js ? `<script>${js}<\/script>` : '';
  // Inject quality CSS fallback only if backend hasn't already injected orbis-polish
  const qualityInject = html.includes('orbis-polish') ? '' : QUALITY_CSS_FALLBACK;
  const headInject = linkTag + styleTag + DARK_SCROLLBAR_CSS + qualityInject;
  if (html.includes('<html')) {
    let doc = html;
    if (headInject) {
      doc = doc.includes('</head>') ? doc.replace('</head>', `${headInject}</head>`) : headInject + doc;
    }
    // Auto-close truncated HTML — if AI ran out of tokens, ensure valid structure
    if (!doc.includes('</body>')) {
      // Strip any partial tag at the end (e.g., '<div class=' or '<sect')
      doc = doc.replace(/<[a-z][^>]*$/i, '');
      // Close any unclosed sections/divs generously
      doc += '</section></div></div></div></main></body></html>';
    }
    doc = doc.replace('</body>', `${scriptTag}${IFRAME_INJECTION}</body>`);
    return doc;
  }
  return `<!DOCTYPE html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1.0">${headInject}<script src="https://unpkg.com/lucide@latest"><\/script></head><body>${html}${scriptTag}${IFRAME_INJECTION}</body></html>`;
}
